import styled from "styled-components"

const PageDiv=styled.div`
width:${props=>`${props.w}%`};
    float:right;
`

export {PageDiv};